import { APIConfigEmail } from "../models/api.config.email";
import BaseService from "./_base.service";

const endpoint = "config/emails";

const ConfigEmailService = {
  ...BaseService<APIConfigEmail>({ endpoint }),
};

export default ConfigEmailService;
